export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/~/d3-interpolate/src/constant.js
// module id = ../../../../d3-interpolate/src/constant.js
// module chunks = 4